module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAxCAMAAABqB5C8AAAAV1BMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////+ORg7oAAAAHHRSTlMALBY49PLTJRENy7uzGtjFsM6pHsC3IiEK2qI98SJppwAAALZJREFUOMu10csOgyAUhGHE1gsUlYLYC+//nN3KySwmUGf95fwkKLjQF/tC5NbbeXlD6PC5mNUoJ9A+IWQEQpdGJjcORC5JRFxqydVcejBom2tRt4jchNCbyVGXOFTz8PnSnIolekKkPIGEWrQiVP7MWFnxrhdU41DHcDQNf416+ElyzlAsGOY31WG4KHctgGtE1GocBYyI7k1RvQrmIHOCRc0xR0VjUzQItiYcjffzslWYdcX6H56nTfg3bhlgAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/images/back.png
// module id = akd5
// module chunks = 1